import PrimaryButton from "components/Form/Buttons/PrimaryButton";
import { useTranslation } from "react-i18next";

export default function AICCRuleGroupHeader({ onAdd }) {
  const [t] = useTranslation();
  return (
    <div className="row justify-content-end aicc-ruleBuilder__rule-header">
      <div className="col-auto">
        <PrimaryButton
          title={t("aiccRuleBuilder.addRuleButtonLabel")}
          icon="fa-solid fa-plus"
          onClick={onAdd}
        />
      </div>
    </div>
  );
}
